// Map of alerting data sources → metadata
export const dataSourceAlertMap = {
  "Rental Leasing": {
    tooltip:
      "Early Indicator-this client has both a mortgage and Rental Leasing as a positive source. See check² guide for further information.",
  },

  Mortgage: {
    tooltip:
      "Early Indicator-this client has both a mortgage and Rental Leasing as a positive source. See check² guide for further information.",
  },

  "Loan Short Term Small Value": {
    tooltip: (check2GuideUrl) => (
      <>
        See{" "}
        <a
          className="AML-Text-Input"
          style={{
            gap: "10px",
            cursor: check2GuideUrl ? "pointer" : "not-allowed",
            opacity: check2GuideUrl ? 1 : 0.5,
          }}
          onClick={() => {
            if (!check2GuideUrl) return;
            window.open(check2GuideUrl, "_blank", "noopener,noreferrer");
          }}
        >
          check² guide
        </a>{" "}
        for further information.
      </>
    ),
  },
};

export const dataSourceAlerts = Object.keys(dataSourceAlertMap);

const SPECIAL_ALERT_TOOLTIPS = {
  "Rental Leasing":
    "Rental leasing agreements can indicate long-term financial commitments that may affect affordability.",

  Mortgage:
    "Mortgage accounts represent secured borrowing and may indicate significant ongoing financial obligations.",

  "Loan Short Term Small Value":
    "Short-term, small-value loans may indicate reliance on high-frequency credit products.",
};

export const getSpecialDataSourceTooltip = (dataSource) =>
  SPECIAL_ALERT_TOOLTIPS[dataSource] || "";

